import React from "react"
import Button from "~/components/Button"
import {useTranslation} from "react-i18next"

const icon = require("~/icons/warehouse_32_blue.svg")
const icon_edit = require("~/icons/action_edit.svg")

const ListItemTenant = () => {
  const {t} = useTranslation()
  return (
    <div className="sh-list-item">
      <img src={icon} alt={"Tenant"} />
      <div className={"content"}>
        <div className="primary">{this.props.name}</div>
        <div className="secondary">{this.props.noOfUsers}</div>
      </div>
      <div className="actions">
        <Button
          to={"/tenants/" + this.props.name.toLowerCase()}
          icon={icon_edit}
          label={t("edit")}
        />
      </div>
    </div>
  )
}
export default ListItemTenant



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemTenant.js